// Polyfill pour l'objet process requis par sharp
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = {
    env: {},
    browser: true,
    version: '',
    versions: {},
    platform: window.navigator.platform.toLowerCase(),
    nextTick: function(cb) { setTimeout(cb, 0); }
  };
}

export default window.process;
